// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { GetDataByIdDataCallDetailParam, BaseResponseDataCallWrapper } from '../../../types';

/**
 * findById
 *
 * @export
 * @tags 通对话管理
 * @link [GET] /data/{id}/dataCallDetail
 * @param id
 */
export function getDataByIdDataCallDetail(
    options: ApiOptions<GetDataByIdDataCallDetailParam, never> & {
        segments: GetDataByIdDataCallDetailParam;
    }
): Promise<BaseResponseDataCallWrapper> {
    return request<never, GetDataByIdDataCallDetailParam, never>('/data/{id}/dataCallDetail', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getDataByIdDataCallDetail',
    });
}

export const meta = [{ tags: ['通对话管理'], path: '/data/{id}/dataCallDetail', method: 'get' }];
